export default "__VITE_ASSET__wsORVQRq__"